(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-switch')) {
    class ShopSwitch extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.key = `shop-switch:${this.dataset.section}`;
        let saved = null;
        try {
          saved = sessionStorage.getItem(this.key);
        } catch (e) {}
        if (saved && this.tabs.some((t) => t.dataset.view === saved)) this.show(saved, false);

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.show(tab.dataset.view, true));
          tab.addEventListener('keydown', (e) => {
            const last = this.tabs.length - 1;
            let next = null;
            if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
            if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = last;
            if (next === null) return;
            e.preventDefault();
            this.show(this.tabs[next].dataset.view, true);
            this.tabs[next].focus();
          });
        });
      }

      show(view, remember) {
        this.tabs.forEach((t) => {
          const on = t.dataset.view === view;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p) => {
          p.hidden = p.dataset.view !== view;
        });
        if (!remember) return;
        try {
          sessionStorage.setItem(this.key, view);
        } catch (e) {}
      }
    }
    customElements.define('shop-switch', ShopSwitch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-rail')) {
    class ReviewRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = [...this.track.children];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.bar = this.querySelector('[data-bar]');
        this.current = this.querySelector('[data-current]');
        this.querySelector('[data-total]').textContent = this.pad(this.cards.length);

        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => this.queue(), { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            this.go(e.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.drag();
        this.update();
      }

      disconnectedCallback() {
        this.resize?.disconnect();
      }

      pad(n) {
        return String(n).padStart(2, '0');
      }

      index() {
        const t = this.track;
        if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) return this.cards.length - 1;
        const start = t.getBoundingClientRect().left + parseFloat(getComputedStyle(t).scrollPaddingLeft || 0);
        let best = 0;
        let dist = Infinity;
        this.cards.forEach((c, i) => {
          const d = Math.abs(c.getBoundingClientRect().left - start);
          if (d < dist) {
            dist = d;
            best = i;
          }
        });
        return best;
      }

      go(step) {
        const i = Math.max(0, Math.min(this.cards.length - 1, this.index() + step));
        const t = this.track;
        const pad = parseFloat(getComputedStyle(t).scrollPaddingLeft || 0);
        const left = this.cards[i].getBoundingClientRect().left - t.getBoundingClientRect().left + t.scrollLeft - pad;
        t.scrollTo({ left });
      }

      queue() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const ratio = Math.min(1, t.clientWidth / t.scrollWidth);
        const progress = max > 0 ? t.scrollLeft / max : 0;
        this.bar.style.setProperty('--w', `${ratio * 100}%`);
        this.bar.style.setProperty('--x', `${progress * (1 / ratio - 1) * 100}%`);
        this.current.textContent = this.pad(this.index() + 1);
        this.prev.disabled = t.scrollLeft <= 4;
        this.next.disabled = max <= 4 || t.scrollLeft >= max - 4;
      }

      // Mouse drag; touch and trackpads already scroll natively.
      drag() {
        const t = this.track;
        let x0 = 0;
        let s0 = 0;
        let moved = false;
        t.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          x0 = e.clientX;
          s0 = t.scrollLeft;
          moved = false;
          const move = (ev) => {
            const dx = ev.clientX - x0;
            if (!moved && Math.abs(dx) < 4) return;
            if (!moved) {
              moved = true;
              t.classList.add('is-dragging');
            }
            t.scrollLeft = s0 - dx;
          };
          const up = () => {
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
            if (!moved) return;
            const snapTo = this.index();
            t.classList.remove('is-dragging');
            const pad = parseFloat(getComputedStyle(t).scrollPaddingLeft || 0);
            const c = this.cards[snapTo];
            t.scrollTo({ left: c.getBoundingClientRect().left - t.getBoundingClientRect().left + t.scrollLeft - pad });
          };
          window.addEventListener('pointermove', move);
          window.addEventListener('pointerup', up);
        });
        t.addEventListener('dragstart', (e) => e.preventDefault());
      }
    }
    customElements.define('review-rail', ReviewRail);
  }

  } catch(e) { console.error(e); }
})();
})();
